import React from 'react'
import styles from './styles'

const ClippingEmptyIcon = () => {
  const classes = styles()
  return (
    <div className={classes.root}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 115.24 97.59"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M101.72,87.73c-.39,1.81-1,2.67-3.13,4.72H30.94" />
        <path d="M20.24,16.18,4.47,16.06c0-12.47,12.71-16,15.77,0,1.56,17,1.88,54.12,2.35,66.12s15.76,15.53,14.59-.94H59.83" />
        <path d="M12.36,5.37s58.58,0,67.17,0c6.6,2.32,7.81,10.11,7.81,21.81" />
        <line x1="28.94" y1="21.71" x2="52.18" y2="21.71" />
        <line x1="28.94" y1="31.76" x2="60.71" y2="31.76" />
        <line x1="28.94" y1="41.29" x2="51.35" y2="41.29" />
        <line x1="28.94" y1="51.53" x2="48" y2="51.53" />
        <line x1="28.94" y1="61.94" x2="48" y2="61.94" />
        <circle cx="79.27" cy="56.96" r="24.76" />
        <line x1="110.22" y1="87.91" x2="96.76" y2="74.44" />
      </svg>
    </div>
  )
}

export default ClippingEmptyIcon
